import Error from "components/form/Error";
import InputAreaPrice from "components/form/InputAreaPrice";
import InputAreaPrime from "components/form/InputAreaPrime";
import LabelArea from "components/form/LabelArea";

import React, { useState, useEffect } from 'react';
import ConfirmDeleteModal from "./ConfirmDeleteModal";
import SelectVehicleCatBasic from "./SelectVehicleCatBasic";

const DynamicAirportPickupInput = ({setSelectedOptions,selectedOptions,setDataInput,dataInput,register,trigger,errors,handleVehicleCategoryChange,handleChange, primeAvailable}) => {
  
  const handleClick = () => {
    setDataInput((prevData) => [
      ...prevData,
      { ['vehicle_type_' + (prevData.length)]: "", ['min_rate_' + (prevData.length)]: "", ['min_km_' + (prevData.length)]: "", ['extra_km_' + (prevData.length)]: "",['prime_' + (prevData.length)] : "" }
    ]);
    setSelectedOptions((prevOptions) => {
      return [...prevOptions];
    });
  };
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
   const [primeStates, setPrimeStates] = useState({}); // Tracks is_prime status for each instance
    useEffect(() => {
      setPrimeStates((prevState) => {
        // Create a new state object by preserving existing indices
        const newPrimeStates = { ...prevState };
    
        dataInput.forEach((item, index) => {
          const vehicleType = item[`vehicle_type_${index}`];
          
          // Only set prime state if not already set (preserve for "add" mode)
          if (
            !newPrimeStates.hasOwnProperty(index) && 
            vehicleType && 
            primeAvailable?.hasOwnProperty(vehicleType)
          ) {
            newPrimeStates[index] = primeAvailable[vehicleType];
          }
        });
    
        return newPrimeStates;
      });
    }, [dataInput, primeAvailable]);
      const handlePrimeStatusChange = (index, primeStatus) => {
        setPrimeStates((prevState) => ({
          ...prevState,
          [index]: primeStatus,
        }));
      };
  const handleDelete = (i) => {
    setSelectedOptions((prevOptions) => {
      const deleteVal = dataInput[i][`vehicle_type_${i}`];
      return prevOptions.filter((option) => option !== deleteVal);
    });
  
    setDataInput((prevData) => {
      const newData = prevData.filter((_, index) => index !== i);
  
      const reIndexedData = newData.map((item, index) => ({
        [`vehicle_type_${index}`]: item[Object.keys(item).find(key => key.startsWith('vehicle_type'))] || "",
        [`min_rate_${index}`]: item[Object.keys(item).find(key => key.startsWith('min_rate'))] || "",
        [`min_km_${index}`]: item[Object.keys(item).find(key => key.startsWith('min_km'))] || "",
        [`extra_km_${index}`]: item[Object.keys(item).find(key => key.startsWith('extra_km'))] || "",
        [`prime_${index}`]: item[Object.keys(item).find(key => key.startsWith('prime'))] || ""
      }));
  
      return reIndexedData;
    });
  };
  const handleDeleteConfirm = () => {
    handleDelete(deleteIndex);
    setShowDeleteModal(false); 
  };
    return (
      <div className="col-span-full relative">
       <div className="grid xl:grid-cols-6 lg:grid-cols-1 gap-5 mb-3 col-span-8" >
          <div className="hidden xl:block">
            <LabelArea label={"Vehicle Type"} />
          </div>
          <div className="hidden xl:block">
          <LabelArea label={"Min Rate"} />
          
          </div>
          <div className="hidden xl:block">
          <LabelArea label={"Min KM"} />
          </div>
          <div className="hidden xl:block">
          <LabelArea label={"Extra KM"} />
          </div>
          <div className="hidden xl:block">
          <LabelArea label={"Prime %"} />
          </div>
          {/* <div className="xl:hidden text-center underline underline-offset-8 mb-3 mt-2">Vehicles and Fares</div> */}
        </div>
        {dataInput.map((val, i) => (
        <div className="grid xl:grid-cols-6 lg:grid-cols-1 gap-5 mb-3 col-span-8" key={i}>
            <div className=""> 
              <SelectVehicleCatBasic
                register={register}
                label="Vehicle Type"
                name={`vehicle_type_${i}`}
                selectedVehicle={val[`vehicle_type_${i}`]} 
                selectedOptions={selectedOptions}
                onChange={(e) => handleVehicleCategoryChange(e,i)}
                onPrimeStatusChange={(primeStatus) => handlePrimeStatusChange(i, primeStatus)}
                type="text"
                placeholder={"--Choose--"}
              />
              <Error errorName={errors[`vehicle_type_${i}`]} />
          
            </div>
            <div className="">
              <InputAreaPrice
                register={register}
                trigger={trigger}
                name={`min_rate_${i}`}
                label="Min Rate"
                type="text"
                maxLength={5}
                value={val[`min_rate_${i}`]} 
                onChangeFunction={(e) => handleChange(e, i)}
                placeholder={"Min Rate"}
              />
              <Error errorName={errors[`min_rate_${i}`]} />
            </div>
            <div className="">
              <InputAreaPrice
                register={register}
                trigger={trigger}
                label="Min KM"
                type="text"
                maxLength={5}
                name={`min_km_${i}`}
                value={val[`min_km_${i}`]}
                onChangeFunction={(e) => handleChange(e, i)}
                placeholder={"Min KM"}
              />
              <Error errorName={errors[`min_km_${i}`]} />
            </div>
            <div className="">
              <InputAreaPrice
                register={register}
                trigger={trigger}
                label="Extra KM"
                type="text"
                maxLength={5}
                name={`extra_km_${i}`}
                value={val[`extra_km_${i}`]}
                onChangeFunction={(e) => handleChange(e, i)}
                placeholder={"Extra KM"}
              />
             <Error errorName={errors[`extra_km_${i}`]} />
            </div>
            {primeStates[i] ? (
  <div className="">
    <InputAreaPrime
      register={register}
      trigger={trigger}
      name={`prime_${i}`}
      label="Prime"
      type="text"
      value={val[`prime_${i}`]} 
      onChangeFunction={(e) => handleChange(e, i)}
      maxLength={2}
      placeholder="0"
    />
    <Error errorName={errors[`prime_${i}`]} />
  </div>
) : (
  "Not available"
)}
            <div className="flex items-center">
            {(Object.keys(dataInput).length)!==1&&
           <button  style={{ top: '1rem', outline: 'none', color: 'grey' }}
           className="ml-8 outline-none"
           type="button"
           aria-label="Remove item"
             onClick={() => {
                  setDeleteIndex(i);
                  setShowDeleteModal(true);
                }}>X</button>
            }   
           
            </div>
            
            
          </div>
        ))}
        <div className="mt-6 lg:mt-1">
  
      <button style={{ color: '#0e9f6e',fontSize:'42px',outline:'none' }} className ="absolute bottom-0 right-0 outline-none" type="button" onClick={handleClick}>+</button>
      </div>
      <ConfirmDeleteModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteConfirm}
      />
      </div>
    );
  };
  
  export default DynamicAirportPickupInput;
  